import { jwtDecode, JwtPayload } from 'jwt-decode'
import { Role } from '~/types/users'

interface AccessTokenPayload extends JwtPayload {
  groups?: string[]
}

export function getUserRoles(): Role[] {
  const user = useUserStore()
  const storeRoles = user?.me?.roles || []

  if (storeRoles.length > 0) return storeRoles as Role[]

  if (user.getTokens.access) {
    try {
      const decoded = jwtDecode<AccessTokenPayload>(user.getTokens.access)
      return (decoded?.groups || []) as Role[]
    } catch {
      return []
    }
  }

  return []
}
